import { AxiosError } from 'axios';
import { useState } from 'react';

import { ApprovedPartnersInterface } from '../../../models/dashboard/dashboard/approved-partners';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { approvedPartnersDataActions } from '../../../redux/slices/approvedPartnersDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useApprovedPartners = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onApprovedPartnersError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onApprovedPartnersSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<ApprovedPartnersInterface>) => {
        dispatch(approvedPartnersDataActions.setApprovedPartners(data));
    };

    const approvedPartners = async () => {
        const url: HttpConfig = {
            url: `ba/v1/dashboard/approved-partners`,
            method: 'get',
        };

        return request(url, onApprovedPartnersSuccess, setLoading, onApprovedPartnersError);
    };

    return { approvedPartners, loading };
};

export default useApprovedPartners;
